/* Ressonância Curativa · rcn.js
   Oferta (2 tiers + guia), checkout direto, galeria, barra fixa, contador, visitantes, toast. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100); }
    catch (e) { return 'R$ ' + (cents / 100).toFixed(2).replace('.', ','); }
  };
  var splitMoney = function (cents) {
    var reais = Math.floor(cents / 100), c = String(cents % 100).padStart(2, '0');
    return { r: reais.toLocaleString('pt-BR'), c: c };
  };
  var ready = function (fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };

  /* ---------- Oferta ---------- */
  function initOffer(el) {
    var data;
    try { data = JSON.parse(el.querySelector('[data-rcn-offer-json]').textContent); } catch (e) { return; }
    var state = { tier: data.default || 'kit' };
    var q = function (s) { return el.querySelector(s); };
    var tiers = el.querySelectorAll('[data-rcn-tier]');
    var gift = q('[data-rcn-gift]');
    var giftInput = gift ? gift.querySelector('input') : null;
    var btn = q('[data-rcn-buy]');
    var err = q('[data-rcn-err]');
    var sticky = document.querySelector('[data-rcn-sticky="' + el.id + '"]');

    function tierData() { return data.tiers[state.tier] || {}; }

    function installment(cents) {
      var n = data.installments || 10, i = (data.rate || 0) / 100;
      if (!cents) return '';
      var pmt = i > 0 ? (cents / 100) * i / (1 - Math.pow(1 + i, -n)) : (cents / 100) / n;
      return n + 'x de ' + fmt(Math.round(pmt * 100));
    }

    function render() {
      var t = tierData();
      tiers.forEach(function (lab) {
        var on = lab.getAttribute('data-rcn-tier') === state.tier;
        lab.classList.toggle('is-on', on);
        var inp = lab.querySelector('input'); if (inp) inp.checked = on;
      });
      var m = splitMoney(t.price || 0);
      var set = function (sel, v) { var n = q(sel); if (n) n.textContent = v; };
      set('[data-rcn-v]', m.r);
      set('[data-rcn-c]', ',' + m.c);
      set('[data-rcn-pix]', fmt(t.pix || t.price || 0));
      set('[data-rcn-ship]', t.ship || '');
      set('[data-rcn-card]', installment(t.price) ? 'No cartão: ' + installment(t.price) + (data.rate ? ' (' + String(data.rate).replace('.', ',') + '%/parcela)' : '') : '');
      var de = q('[data-rcn-de]');
      if (de) { de.hidden = !t.compare; var s = de.querySelector('s'); if (s) s.textContent = fmt(t.compare || 0); }
      if (btn) btn.textContent = t.cta || btn.textContent;
      if (gift) { gift.classList.toggle('is-off', state.tier !== 'kit'); if (giftInput) giftInput.checked = state.tier === 'kit'; }
      (el.closest('.rcn-hero') || document).querySelectorAll('[data-rcn-only]').forEach(function (n) { n.hidden = n.getAttribute('data-rcn-only') !== state.tier; });
      if (sticky) {
        var sp = sticky.querySelector('[data-rcn-sticky-price]');
        if (sp) sp.innerHTML = (t.compare ? '<s>' + fmt(t.compare) + '</s>' : '') + fmt(t.price || 0);
        var sn = sticky.querySelector('[data-rcn-sticky-name]'); if (sn) sn.textContent = t.label || '';
      }
    }

    tiers.forEach(function (lab) {
      lab.addEventListener('click', function (e) { e.preventDefault(); state.tier = lab.getAttribute('data-rcn-tier'); render(); });
      lab.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); state.tier = lab.getAttribute('data-rcn-tier'); render(); } });
    });
    if (gift) gift.addEventListener('click', function (e) {
      e.preventDefault();
      state.tier = state.tier === 'kit' ? 'solo' : 'kit';
      render();
    });

    function resolveVariant(t) {
      if (!t.handle) return t.variant ? Promise.resolve(String(t.variant)) : Promise.reject(new Error('Produto não configurado.'));
      return fetch(root + 'products/' + encodeURIComponent(t.handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('Produto indisponível no momento.'); return r.json(); })
        .then(function (p) {
          var vs = (p && p.variants) || [];
          var v = vs.find(function (x) { return String(x.id) === String(t.variant) && x.available; }) || vs.find(function (x) { return x.available; });
          if (!v) throw new Error('Produto esgotado no momento.');
          return String(v.id);
        });
    }

    function buy() {
      var t = tierData();
      if (!btn || btn.classList.contains('is-loading')) return;
      var label = btn.textContent;
      btn.classList.add('is-loading'); btn.textContent = 'Indo para o pagamento…';
      if (err) err.classList.remove('is-on');
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' })
        .catch(function () { return null; })
        .then(function () { return resolveVariant(t); })
        .then(function (id) {
          return fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Não foi possível adicionar.'); return d; }); });
        })
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function (e) {
          btn.classList.remove('is-loading'); btn.textContent = label;
          if (err) { err.textContent = (e && e.message ? e.message + ' ' : '') + 'Tente de novo ou chame a gente no WhatsApp.'; err.classList.add('is-on'); }
        });
    }
    if (btn) btn.addEventListener('click', buy);
    if (sticky) {
      var sb = sticky.querySelector('[data-rcn-sticky-buy]');
      if (sb) sb.addEventListener('click', function () {
        if (data.stickyScroll) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } else { buy(); }
      });
      if (btn) {
        var ticking = false;
        var check = function () {
          ticking = false;
          var r = btn.getBoundingClientRect();
          sticky.classList.toggle('is-on', r.bottom < 0);
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        window.addEventListener('resize', check, { passive: true });
        check();
      }
    }
    render();
  }

  /* ---------- Galeria ---------- */
  function initGallery(g) {
    var track = g.querySelector('.rcn-gallery__track');
    var slides = track ? track.children : [];
    var dots = g.querySelectorAll('[data-rcn-dot]');
    var thumbs = g.querySelectorAll('[data-rcn-thumb]');
    if (!track || slides.length < 2) return;
    var go = function (i) { track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }, 60);
    }, { passive: true });
  }

  /* ---------- Contador ---------- */
  function initTimer(el) {
    var mins = parseInt(el.getAttribute('data-rcn-timer'), 10) || 60;
    var key = 'rcn_timer_end_' + mins, end;
    try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) { end = 0; }
    var now = Date.now();
    if (!end || end < now) { end = now + mins * 60000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    (function tick() {
      var left = Math.max(0, end - Date.now());
      if (left === 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} left = mins * 60000; }
      var sec = Math.floor(left / 1000);
      if (h) h.textContent = pad(Math.floor(sec / 3600));
      if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (s) s.textContent = pad(sec % 60);
      setTimeout(tick, 1000);
    })();
  }

  /* ---------- Visitantes ---------- */
  function initViewers(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 120, max = parseInt(el.getAttribute('data-max'), 10) || 260;
    var n = el.querySelector('[data-n]'); if (!n) return;
    var v; try { v = parseInt(sessionStorage.getItem('rcn_viewers'), 10); } catch (e) {}
    if (!v || v < min || v > max) { v = Math.floor(min + Math.random() * (max - min)); }
    var draw = function () { n.textContent = v; try { sessionStorage.setItem('rcn_viewers', String(v)); } catch (e) {} };
    draw();
    setInterval(function () { v = Math.min(max, Math.max(min, v + (Math.random() < .6 ? 1 : -1) * Math.ceil(Math.random() * 3))); draw(); }, 9000);
  }

  /* ---------- Toast de atividade ---------- */
  function initToast(el) {
    var items; try { items = JSON.parse(el.querySelector('[data-rcn-toast-json]').textContent); } catch (e) { return; }
    if (!items || !items.length) return;
    var box = el.querySelector('.rcn-toast'), i = 0;
    var first = parseInt(el.getAttribute('data-delay'), 10) || 12, gap = parseInt(el.getAttribute('data-gap'), 10) || 25;
    function show() {
      var it = items[i % items.length]; i++;
      box.querySelector('[data-t]').textContent = it.t || '';
      box.querySelector('[data-s]').textContent = it.s || '';
      var img = box.querySelector('img'); if (img) { if (it.img) { img.src = it.img; img.hidden = false; } else { img.hidden = true; } }
      box.classList.add('is-on');
      setTimeout(function () { box.classList.remove('is-on'); }, 5200);
      setTimeout(show, gap * 1000);
    }
    setTimeout(show, first * 1000);
  }

  /* ---------- Vídeos: toca ao tocar ---------- */
  function initVideos(root) {
    root.querySelectorAll('.rcn-video video').forEach(function (v) {
      v.addEventListener('click', function () { v.muted = !v.muted; if (v.paused) v.play(); });
    });
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-rcn-offer]').forEach(initOffer);
    scope.querySelectorAll('.rcn-gallery').forEach(initGallery);
    scope.querySelectorAll('[data-rcn-timer]').forEach(initTimer);
    scope.querySelectorAll('[data-rcn-viewers]').forEach(initViewers);
    scope.querySelectorAll('[data-rcn-toasts]').forEach(initToast);
    initVideos(scope);
  }
  ready(function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
